import { useQueryStates } from 'nuqs';
import { useCallback } from 'react';
import { contactDrawerParsers } from '../../contact-drawer-url-state';

/**
 * The PUBLICITE view's navigation, in URL state.
 *
 * List, detail and composer are three levels of one view, not three components
 * fighting over local state: the context bar's back arrow already walks the URL,
 * so a local state machine here would silently eat one of its levels. Being in
 * the URL also means a reload, a browser Back, or a link pasted into a support
 * thread all land on the same screen.
 */
export function useContactAdDrilldown() {
  const [{ contactAd, contactAdCompose }, setParams] = useQueryStates(contactDrawerParsers);

  const openDetail = useCallback(
    (authorizationId: string) => {
      void setParams({ contactAd: authorizationId, contactAdCompose: null });
    },
    [setParams]
  );

  const openComposer = useCallback(
    (authorizationId: string) => {
      void setParams({ contactAd: authorizationId, contactAdCompose: true });
    },
    [setParams]
  );

  /** Composer -> detail. The proposal just sent is on the screen behind. */
  const closeComposer = useCallback(() => {
    void setParams({ contactAdCompose: null });
  }, [setParams]);

  /** Detail -> list. */
  const closeDetail = useCallback(() => {
    void setParams({ contactAd: null, contactAdCompose: null });
  }, [setParams]);

  return {
    authorizationId: contactAd,
    isComposing: contactAdCompose,
    openDetail,
    openComposer,
    closeComposer,
    closeDetail,
  };
}
